<script lang="ts">
  export let width: string = "100%"
  export let height: string = "14px"
  export let padding: string = "0"
</script>

<div class="skeleton" style="width: {width}; padding: {padding} 0;">
  <div style="height: {height};" />
</div>

<style>
  .skeleton > div {
    border-radius: 4px;
    animation: skeleton-loading 1s linear infinite alternate;
    width: 100%;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(212, 64%, 82%);
    }
    100% {
      background-color: hsl(212, 64%, 95%);
    }
  }
</style>
